import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import es from 'javascript-time-ago/locale/es';
import fr from 'javascript-time-ago/locale/fr';
import pt from 'javascript-time-ago/locale/pt';
import ja from 'javascript-time-ago/locale/ja';
import tr from 'javascript-time-ago/locale/tr';
import id from 'javascript-time-ago/locale/id';
import zh from 'javascript-time-ago/locale/zh';

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(es);
TimeAgo.addLocale(fr);
TimeAgo.addLocale(pt);
TimeAgo.addLocale(ja);
TimeAgo.addLocale(tr);
TimeAgo.addLocale(id);
TimeAgo.addLocale(zh);

export const getCurrentLanguage = () => i18n?.languages?.[0];

export const defaultLanguage = 'en';
export const supportedLanguages = [
  'en',
  'es',
  'fr',
  'pt',
  'ja',
  'tr',
  'id',
  'zh'
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    whitelist: supportedLanguages,
    nonExplicitWhitelist: true,
    load: 'languageOnly',
    fallbackLng: {
      default: [defaultLanguage],
      ...Object.fromEntries(
        supportedLanguages
          .filter((lang) => lang !== defaultLanguage)
          .map((lang) => [lang, [lang]])
      )
    },
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
